import React, { Component } from 'react';
import ReactTable from "react-table/lib";
import { Row, Col } from 'reactstrap';
import HttpUtil from '../../Util/httpUtil';
import CheckBoxRevisado from './CheckBoxRevisado';
import '../../_Content/css/resultado.css';
import "react-table/react-table.css";
import { ReactTableDefaults } from "react-table";
import Config from '../../Util/config';
import TooltippedCel from "../../Componente/Common/TooltippedCel";

Object.assign(ReactTableDefaults, {
	nextText: 'Proxíma',
	previousText: 'Anterior',
	noDataText: 'Nenhum resultado encontrado',
	pageText: 'Pag.',
	ofText: 'de'
});

class ResultadoExpandidoErros extends Component {

	constructor(props) {
		super(props);
		this.state =
			{
				lista: [],
				loading: true,
				pageSize: 1,
				quantidadeErros: 0,
				quantidadeTotalErros: this.props.quantidadeErros,
				exibirCarregarMais: true,
				colunas: [
					{
						Header: "Linha",
						accessor: "LINHA",
						className: 'text-center txt',
						Cell: row => (<span>{row.value == 0 ? "-" : row.value}</span>)
					},
					{
						Header: "Valor informado",
						accessor: "VALORINFORMADO",
						className: 'text-center txt'
					},
					{
						Header: "Valor esperado",
						accessor: "VALORESPERADO",
						className: 'text-center txt',
						Cell: row => (
							<TooltippedCel placement="left-start" text={row.value} />
						)
					},
					{
						Header: "Numero da Nota",
						className: 'text-center txt',
						show: this.props.moduloEfd.toLowerCase() == "ecf" ? false : true,
						Cell: row => (<span>{row.original.NUMERODOCUMENTO ? row.original.NUMERODOCUMENTO : "-"}</span>)
					},
					{
						Header: "Revisou o item?",
						className: 'text-center',
						Cell: row => (<CheckBoxRevisado row={row.row._original} id_arquivo={this.props.id_arquivo} moduloEfd={this.props.moduloEfd} />)
					}
				]
			};

		this.prepararRequestData();
	}

	requestData = () => {
		return new Promise((resolve, reject) => {
			let urlApi = this.props.moduloEfd === "Fiscal" ? Config.urls.API_URL_FISCAL
				: this.props.moduloEfd === "ECF" ? Config.urls.API_URL_ECF
				: this.props.moduloEfd === "ECD" ? Config.urls.API_URL_ECD
				: Config.urls.API_URL_CONT;
			let url = `${urlApi}Validacao/ExibirErros/${this.props.id_arquivo}/${this.props.registro}/${this.props.campo}/${this.props.ocorrencia}/${this.state.quantidadeErros}/${this.state.quantidadeErros < 10 ? 10 : 50}`;
			HttpUtil.eco_GET(url, (response) => {
				resolve({ rows: response.data });
			}, () => { console.log("Error ExibirErrosEstrutura"); });
		});
	};

	prepararRequestData = () => {
		this.setState({ loading: true });
		this.requestData().then(res => {
			this.setState({
				quantidadeErros: this.state.quantidadeErros + Object.keys(res.rows).length,
				lista: this.state.lista.concat(res.rows)
			});
			this.setState({
				pageSize: Object.keys(this.state.lista).length > 0 ? Object.keys(this.state.lista).length : 1,
				loading: false,
				exibirCarregarMais: this.state.quantidadeErros < this.state.quantidadeTotalErros
			});
		});
	};

	onClickCarregarMaisErros(event) {
		event.preventDefault();
		this.prepararRequestData();
	}

	render() {

		return (
			<Row md={12}>
				<Col md={12}>
					<ReactTable
						noDataText="Nenhum resultado encontrado"
                        data={this.state.lista}
                        className="eco-react-table-inner"
						columns={this.state.colunas}
						showPagination={false}
						loading={this.state.loading}
						pageSize={this.state.pageSize} />

					{/* Carregar mais erros e exibir numero de erros */}
					<Row md={12} className="mt-3 mb-3">
						<Col md={4}></Col>

						<Col md={4} className="text-center text-carregar-mais-erros">
							{this.state.exibirCarregarMais &&
								<a href="#" onClick={this.onClickCarregarMaisErros.bind(this)}>
									<span className="pr-2">Carregar mais erros</span>
									<i className="ecoico ecoico-setabaixo" />
								</a>
							}
						</Col>
						<Col md={4} className="span-quantidade-erros-resultado">
							<span>Exibindo {this.state.quantidadeErros} de {this.state.quantidadeTotalErros}</span>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}
}

export default ResultadoExpandidoErros;


// WEBPACK FOOTER //
// ./src/Componente/Resultado/ResultadoExpandidoErros.jsx